import { Flex } from '@radix-ui/themes'
import ReactMarkdown from 'react-markdown'
import { type MetaFunction } from 'react-router'
import { GeneralErrorBoundary } from '#app/components/ui/error-boundary.js'
import { ProseContent } from '#app/components/ui/prose-content.js'
import termsContent from '#app/content/terms.md?raw'

export default function TermsPage() {
  return (
    <main>
      <Flex flexGrow="0" justify="between" className="mb-4">
        <h1 className="text-xl font-bold leading-none">Terms of Service</h1>
      </Flex>

      <ProseContent>
        <ReactMarkdown>{termsContent}</ReactMarkdown>
      </ProseContent>
    </main>
  )
}

export const meta: MetaFunction = () => {
  return [{ title: 'Terms of Service | DEx' }]
}

export function ErrorBoundary() {
  return <GeneralErrorBoundary />
}
